module.exports = __webpack_public_path__ + "img/card-logo.bc84327e.svg";